import React from 'react';
import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';

const { createSliderWithTooltip } = Slider;
const Range = createSliderWithTooltip(Slider.Range);
const backgroundHandler = { backgroundColor: 'red' };
export function PriceSlider({ setpriceRange, priceRange }) {
    return (
        <div>
            <Range
                min={0}
                max={50000}
                allowCross={false}
                trackStyle={backgroundHandler}
                value={[priceRange.minValue, priceRange.maxValue]}
                tipFormatter={(value) => `${value}₹`}
                onChange={(val) => {
                    setpriceRange((state) => ({
                        ...state,
                        minValue: val[0],
                        maxValue: val[1],

                    }));
                    setpriceRange({
                        minValue: val[0],
                        maxValue: val[1],
                    });
                }}
            />
        </div>
    );
}
